import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import axios from "src/utils/axios";
import { getUser,safeRequestParam } from 'src/utils/Common';
import * as Survey from "survey-react";
import 'react-confirm-alert/src/react-confirm-alert.css';
import logger from 'src/utils/logger';

const useStyles = makeStyles(() => ({
  root: {},
}));


function GenericAnket({ anketOpen, setAnketOpen, anketTitle, anketId, basvuruNo, birimKodu, durum, kulModelKodu, alinanSms, setFisNo, setAnketKapandi }) {

  const classes = useStyles();
  const [anketData, setAnketData] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [mesaj, setMesaj] = useState('Anket Başarıyla Tamamlandı.');
  const [anketBitti, setAnketBitti] = useState(false);
  const [anketGoster, setAnketGoster] = useState(false);


  useEffect(() => {
    let isMounted = true;
    if (!anketOpen) {
      return;
    }
    setLoading(true);
    axios.get(`GetArtemisAnketV2/${basvuruNo || 0}/${birimKodu || 0}/${durum || 0}/${safeRequestParam(kulModelKodu) || 'A'}/${safeRequestParam(alinanSms) || 'A'}/${anketId}`)
      .then(response => {
        if (!isMounted) return;
        response.data.length === 0 ? handleAnketBitti('Anket Daha Önce Tamamlandı.') : anketBaslat(response.data);
        setLoading(false);
      }).catch(error => {
        if (!isMounted) return;
        setLoading(false);
        logger.error("Hata detayı:", error.message);
      });

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [anketId, basvuruNo, birimKodu, kulModelKodu, alinanSms, durum, anketOpen]);

  const anketBaslat = (data) => {
    setAnketData(data);
    setAnketGoster(true);
  }

  const handleAnketBitti = (msg) => {
    setAnketBitti(true);
    setMesaj(msg);
    if (setAnketOpen) {
      setAnketOpen(false);
    }
  }

  const handleAnketKapat = () => {
    setAnketOpen(false);
    setAnketGoster(false);
    if (setAnketKapandi)
      setAnketKapandi(true);
  }

  const onComplete = (survey) => {
    setLoading(true);
    let cevaplar = {};
    let anketId = Object.keys(survey.data)[0]?.split('-')[0];
    Object.keys(survey.data).forEach(k => {
      cevaplar = {
        ...cevaplar,
        [k.replace(anketId + '-', '')]: survey.data[k]
      }
    });
    const user = getUser();
    const data = {
      FisNo: setFisNo || 0,
      TeknisyenKodu: user.TechnicianId,
      AnketId: anketId,
      Cevaplar: cevaplar,
      Pilot: 1,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisAnket', { jsonString: JSON.stringify(data) }, config)
      .then((response) => {
        const data = response.data;
        if (data.ErrorCode && parseInt(data.ErrorCode) === 0) {
          handleAnketBitti('Anket Başarıyla Tamamlandı.');
          setLoading(false);
        } else {
          handleAnketBitti('Hata Oluştur.Hata Kodu: ' + data.ErrorCode + ' Hata Açıklama: ' + data.ErrorDescription);
          setLoading(false);
        }
      }).catch((error) => {
        handleAnketBitti('Hata Oluştur.Hata: ' + error.message);
        setLoading(false);
      });
  };


  var defaultThemeColors = Survey
    .StylesManager
    .ThemeColors["default"];
  defaultThemeColors["$main-color"] = "#FF9800";
  defaultThemeColors["$main-hover-color"] = "#FF9800";
  defaultThemeColors["$text-color"] = "#424242";

  Survey
    .StylesManager
    .applyTheme();

  Survey.surveyLocalization.defaultLocale = "tr";
  var modelGenericAnker = new Survey.Model(anketData);
  modelGenericAnker.locale = 'tr';


  return (
    <Dialog
      open={anketGoster}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleAnketKapat(); // Sadece arka plana tıklanmadığı (mesaj veya butonla kapatıldığı) durumlarda kapat
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}

    >
      <DialogTitle id="alert-dialog-title">
        {anketTitle}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {Loading ? <CircularProgress
          status="loading"
          style={{ marginLeft: '50%' }}
        />
          :
          (anketBitti ? mesaj
            :
            <Survey.Survey json={anketData} onComplete={onComplete} />
          )
        }
      </DialogContent>
      <Divider />
      <DialogActions>
        {anketBitti &&
          <Button
            variant="contained"
            color="secondary"
            onClick={() => handleAnketKapat()}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
}

export default GenericAnket;
